<template>
  <div>
    <b-form @submit="onSubmit">
      <b-modal id="new-tenant-modal" title="New tenant" @hide="onClose">
        <b-form-group label="Tenant group" label-for="group">
          <b-form-select
            id="group"
            v-model="group"
            data-cy="new-tenant-modal-group-input"
            required
            :state="isGroupValid"
            :options="groups"
            @change="validateGroup"
          ></b-form-select>
        </b-form-group>

        <b-form-group label="Tenant Name" label-for="name">
          <b-form-input
            id="name"
            v-model="name"
            data-cy="new-tenant-modal-name-input"
            placeholder="Enter a name"
            required
            :state="isNameValid"
            @input="validateName"
          ></b-form-input>
        </b-form-group>
        <template v-slot:modal-footer>
          <b-button variant="secondary" @click="onClose"> Cancel </b-button>
          <b-button
            type="submit"
            variant="primary"
            data-cy="new-tenant-modal-submit-btn"
            @click="onSubmit"
            >Create</b-button
          >
        </template>
      </b-modal>
    </b-form>
  </div>
</template>

<script>
export default {
  name: 'newTenantPopup',

  props: {
    groups: {
      type: Array,
      required: true
    }
  },

  data() {
    return {
      name: null,
      group: null,
      isNameValid: null,
      isGroupValid: null
    };
  },

  methods: {
    onSubmit() {
      this.validateName();
      this.validateGroup();

      if (this.isNameValid && this.isGroupValid) {
        this.$emit('form-submitted', { name: this.name, group: this.group });
        this.$bvModal.hide('new-tenant-modal');
      }
    },
    validateName() {
      this.isNameValid = this.name ? true : false;
    },
    validateGroup() {
      this.isGroupValid = this.groups.includes(this.group);
    },
    onClose() {
      this.$bvModal.hide('new-tenant-modal');
      this.isGroupValid = null;
      this.isNameValid = null;
      this.name = null;
      this.group = null;
    }
  }
};
</script>
